// extracted by mini-css-extract-plugin
export default {"pageSize":"page-size-module__pageSize--A0oxB","pageSizeLabel":"page-size-module__pageSizeLabel--Myqyk","pageSizeSelectContainer":"page-size-module__pageSizeSelectContainer--RMVrI"};